import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgDocumentsUrl from '@/assets/misc/img_documents.svg'
import NoBillingMethodsIllustration from '@/components/SpotIllustration/NoBillingMethodsIllustration'

export interface StartProgressionDialogProps {
  showing: boolean
  corporateMode: boolean
  isReview: boolean
  isStartPending: boolean
  onClose: () => unknown
  onStart: () => unknown
}

export function StartProgressionDialog({
  showing,
  corporateMode,
  isReview,
  isStartPending,
  onClose,
  onStart,
}: StartProgressionDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isStartPending ? undefined : onClose}
      testId="job-progression-start-dialog"
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgDocumentsUrl}
              illustration={byDesign(undefined, NoBillingMethodsIllustration)}
              alt="Woman typing on a computer."
            />
          )}
          <ModalSheetContentTitle>
            Do you have all the documents needed to continue{' '}
            {isReview ? 'the review?' : 'preparation?'}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            By continuing, you confirm that there are no missing items.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isStartPending}
          />
          <Button
            label={isReview ? 'Continue Review' : 'Continue Preparation'}
            type="submit"
            isPending={isStartPending}
            isDisabled={isStartPending}
            onPress={onStart}
            variant="primary"
            testId="job-progression-set-job-started-dialog-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
